<button class="btn btn-default" (click)="open()">Show details</button>
<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Subscription history</h5>
    <a type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <img aria-hidden="true" src="assets/images/icons/cancel.png" width="12"/>
    </a>
  </div>
  <div class="modal-body text-center">
    <app-subscription-item-list [subscriptionId]="subscriptionId()"></app-subscription-item-list>
  </div>

</ng-template>
